import { useLayoutEffect } from "react";

export default function DetailViewStageState({ activeView = null, mountNode = null, standardViewNode = null }) {
  useLayoutEffect(() => {
    if (!(mountNode instanceof HTMLElement)) {
      return undefined;
    }

    const detailPanels = Array.from(mountNode.querySelectorAll("[data-detail-panel]"))
      .filter((panel) => panel instanceof HTMLElement);
    const normalizedActiveView = typeof activeView === "string" ? activeView : "";

    if (normalizedActiveView) {
      mountNode.setAttribute("data-active-view", normalizedActiveView);
      mountNode.style.display = "grid";
    } else {
      mountNode.removeAttribute("data-active-view");
      mountNode.style.display = "none";
    }

    if (standardViewNode instanceof HTMLElement) {
      standardViewNode.style.display = normalizedActiveView ? "none" : "";
      standardViewNode.setAttribute("aria-hidden", normalizedActiveView ? "true" : "false");
    }

    detailPanels.forEach((panel) => {
      const isActivePanel = panel.dataset.detailPanel === normalizedActiveView;
      panel.style.display = isActivePanel ? "block" : "none";
      panel.setAttribute("aria-hidden", isActivePanel ? "false" : "true");
    });

    return () => {
      mountNode.removeAttribute("data-active-view");
      mountNode.style.display = "";
      if (standardViewNode instanceof HTMLElement) {
        standardViewNode.style.display = "";
        standardViewNode.removeAttribute("aria-hidden");
      }
      detailPanels.forEach((panel) => {
        panel.style.display = "";
        panel.removeAttribute("aria-hidden");
      });
    };
  }, [activeView, mountNode, standardViewNode]);

  return null;
}